"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppSelector = void 0;
var _reactRedux = require("react-redux");
var _useProps = _interopRequireDefault(require("./useProps"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useAppSelector = selectorFunction => {
  var _instanceId$replace;
  const {
    __instanceId
  } = (0, _useProps.default)();
  const result = (0, _reactRedux.useSelector)(selectorFunction((_instanceId$replace = __instanceId === null || __instanceId === void 0 ? void 0 : __instanceId.replace(/-/g, '_')) !== null && _instanceId$replace !== void 0 ? _instanceId$replace : 'instance_id'));
  return result;
};
exports.useAppSelector = useAppSelector;